import api from "../api";

export const getStatutoryApprovals = (params) =>
 api.get("/statutory-approvals", { params });

export const getStatutoryApproval = (id) =>
 api.get(`/statutory-approvals/${id}`);

export const createStatutoryApproval = (data) =>
 api.post("/statutory-approvals", data, {
 headers: { "Content-Type": "multipart/form-data" },
 });

export const updateStatutoryApproval = (id, data) =>
 api.patch(`/statutory-approvals/${id}`, data, {
 headers: { "Content-Type": "multipart/form-data" },
 });

export const deleteStatutoryApproval = (id) =>
 api.delete(`/statutory-approvals/${id}`);

export const downloadStatutoryApprovalPdf = (id) =>
 api.get(`/statutory-approvals/${id}/pdf`, {
 responseType: "blob",
 });

export const getStatutoryApprovalStats = (params) =>
 api.get("/statutory-approvals/stats", { params });
